const getName = (names: Array<null | string | undefined>) => names.filter(Boolean).join(' ').trim();

/**
 * @deprecated Use useGetUserNameWithFallback instead.
 */
export const getUserName = ({ firstName, lastName }: { firstName?: null | string; lastName?: null | string }) =>
  getName([firstName, lastName]);
